module.exports = __webpack_public_path__ + "img/audr.09f037c3.svg";